import { Outlet, useLocation } from 'react-router-dom';
import classnames from 'classnames';
import Footer from '@/components/footer';
import Header from '@/components/header';
import Breadcrumb from '@/components/breadcrumbs';

import classes from './index.module.scss';
import ButtonGroup from '@/components/buttonGroup';
import { useState } from 'react';

const Layout = () => {
  const path = useLocation();
  // 存储当前路径
  const currentPath = path.pathname;
  const hasBreadcrumb = !['/loginIn', '/productList', '/home', '/homePage', '/mobile'].includes(currentPath);
  const [productList, setProduct] = useState([]);
  // console.log(currentPath !== '/loginIn' && currentPath !== '/homePage', '123');

  return (
    <main className={classes.main}>
      {currentPath !== '/loginIn' && currentPath !== '/homePage'&& currentPath !== '/mobile'  && <Header setProduct={setProduct}/>}
      {/* <Header /> */}
      <section className={classnames(classes.page, { [classes.hasBreadcrumb]: !hasBreadcrumb })}>
        {hasBreadcrumb && <Breadcrumb className={classes.breadcrumb} />}
        <Outlet />
      </section>
      {currentPath !== '/loginIn' && currentPath !== '/homePage'&& currentPath !== '/mobile' && <ButtonGroup />}
      {currentPath !== '/loginIn' && currentPath !== '/homePage'&& currentPath !== '/mobile' && <Footer productList={productList}/>}
    </main>
  );
};

export default Layout;
